import React, { useContext } from 'react';
import { Box, Button, Tooltip } from '@material-ui/core';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useSelector } from 'react-redux';

import { ModalStep } from 'components/Flow/components/ModalStep';
import Img from 'retired/Img';
import InfoCirclePurple from 'assets/icons/info-circle-purple.svg';
import { darkPurple, white } from 'utils/color-styles';
import { Privileges } from 'utils/privileges';
import { ModalTitle, ModalTypography } from 'components/Modal/Modal';
import { computeDonationProviderForNonprofit } from 'utils/computeDonationProviderForNonprofit';
import { selectUser } from 'entities/user/selectors';
import { StepComponentProps } from 'components/Flow/RenderMachine';
import { BackButton } from 'components/BackButton/BackButton';

import { NonprofitOnboardingFlowContext } from '../../nonprofitOnboarding/context';

import { useContent } from './useContent';

export const PaymentStep = ({ send, state, isTransitionAllowed }: StepComponentProps) => {
  const user = useSelector(selectUser);

  const {
    state: parentState,
    isTransitionAllowed: isTransitionAllowedParent,
    send: sendParent,
  } = useContext(NonprofitOnboardingFlowContext) || {};

  const allowedSteps = parentState?.context?.allowedSteps || [];
  const currentStep = allowedSteps.indexOf(parentState?.value) + 1;

  const donationProvider =
    user?.organization &&
    computeDonationProviderForNonprofit(
      user?.organization,
      user?.organization?.settings?.get('preferStripe') || false
    );

  const selfVerified = user?.hasPrivilege(Privileges.ORGANIZATION_SELF_VERIFIED);

  const content = useContent(donationProvider, user?.organization, selfVerified);

  return (
    <ModalStep
      showProgressBar
      actions={
        <div style={{ color: darkPurple }}>
          {isTransitionAllowedParent?.('PREV') && (
            <BackButton onClick={(): unknown => sendParent?.('PREV')} />
          )}
          {!state.context?.standaloneMode && isTransitionAllowed?.('SKIP') && (
            <Button
              color="inherit"
              type="button"
              endIcon={<ArrowForwardIcon style={{ fontSize: 16 }} />}
              style={{ marginRight: 8 }}
              onClick={(): unknown => send('SKIP')}
            >
              Skip
            </Button>
          )}
          <Button
            type="button"
            variant="contained"
            style={{ backgroundColor: darkPurple, color: white }}
            onClick={(): unknown => send({ type: 'ENROLL', location: content.link })}
          >
            {content.ctaText}
          </Button>
        </div>
      }
      header={
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '16px 0 32px',
            height: 209,
          }}
        >
          <Img
            src={content.logo}
            style={{
              width: donationProvider ? 230 : 150,
            }}
          />
        </Box>
      }
    >
      {currentStep === 1 && (
        <>
          <ModalTitle size="large">Welcome to Deed!</ModalTitle>
          <ModalTypography>
            Your home for corporate giving, volunteering, and relationship-building!
          </ModalTypography>
        </>
      )}
      <ModalTitle style={{ lineHeight: '28px' }}>
        {content.header}
        {content.tooltip && (
          <Tooltip placement="right" title={content.tooltip}>
            <span style={{ display: 'inline-block', marginLeft: 4, transform: 'translateY(-2px)' }}>
              <Img
                src={InfoCirclePurple}
                style={{
                  height: 'max-content',
                }}
              />
            </span>
          </Tooltip>
        )}
      </ModalTitle>

      <ModalTypography>{content.body}</ModalTypography>
    </ModalStep>
  );
};
